type LatLng = google.maps.LatLng;
type LatLngLiteral = google.maps.LatLngLiteral;

export interface StrCoordinates {
  latitude: string
  longitude: string
}

export interface DistributorItem {
  Id: string
  Location__c: StrCoordinates
  Name: string
  Visit_Street__c: string
  Visit_City__c: string
  Phone: string
  Emergency_Phone_Number__c?: string
  Website?: string
  Visit_Zip_Code__c: string
  Visit_Country__c: string
  Additional_Name__c?: string
  Workshop_Partsdealer_Type__c: string
  Additional_Skills_Service_Partners__c: string
}

/**
 * Find distributors nearby the given location
 */
export const findDistributors = async (apiUrl: string, distributorType: string, distance: string, distanceUnit: string, coordinates: LatLng | LatLngLiteral, skills: string): Promise<DistributorItem[]> => {
  const latLng = new google.maps.LatLng(coordinates)

  const response = await fetch(apiUrl, {
    method: 'POST',
    body: new URLSearchParams({
      accountId: '',
      lat: latLng.lat().toString(),
      lng: latLng.lng().toString(),
      distanceUnit: distanceUnit,
      distance: distance.toString(),
      industries: distributorType,
      skills: skills
    })
  })

  const distributors = await response.json()

  if (typeof distributors === 'string') {
    // TODO: Workaround.
    //  API currently returns a json string that contains the json payload.
    //  »"[...]"« .
    const extendedPayload = `{"payload": ${distributors}}`
    return JSON.parse(extendedPayload).payload
  }

  return distributors
}

